import React from 'react';

interface Props {
    isRuleEmpty: boolean;
    showNoMatchHint: boolean;
}

export const PlanVehicleRuleHints: React.FC<Props> = ({ isRuleEmpty, showNoMatchHint }) => (
    <>
        {isRuleEmpty && (
            <p className="text-xs text-mp-info" role="status" data-testid="pvr-any-vehicle-hint">
                This rule will match every vehicle.
            </p>
        )}
        {showNoMatchHint && (
            <p className="text-xs text-mp-warning" role="status" data-testid="pvr-no-match-hint">
                No current derivatives match this combination.
            </p>
        )}
    </>
);
